export default (state, category) => {
  state.vehicleCategory = category;
}
